module.exports = {"320509100":"太湖新城镇","320509104":"平望镇","320509105":"盛泽镇","320509107":"七都镇","320509108":"震泽镇","320509109":"桃源镇","320509110":"黎里镇","320509400":"吴江经济技术开发区","320509401":"东方丝绸市场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320509.json
// module id = 804
// module chunks = 0